<svelte:options runes={false} />

<script>
  import { THEME_OPTIONS } from '../../api/themes';
  import CurrencySelect from './CurrencySelect.svelte';

  export let selectedThemeId;
  export let themeSavePending;
  export let canManage;
  export let onSelectTheme;
  export let accountDefaultCurrency;
  export let accountCurrencySavePending;
  export let onSelectDefaultCurrency;
</script>

<label>
  Account theme
  <select
    disabled={themeSavePending || !canManage}
    value={selectedThemeId}
    on:change={onSelectTheme}
  >
    {#each THEME_OPTIONS as theme (theme.id)}
      <option value={theme.id}>{theme.label}</option>
    {/each}
  </select>
</label>
<CurrencySelect
  label="Default invoice currency"
  disabled={accountCurrencySavePending || !canManage}
  value={accountDefaultCurrency}
  onChange={onSelectDefaultCurrency}
/>
<p class="quiet">This defaults new drafts only; existing invoices keep their currency.</p>
